import ReadMore from '@stimulus-components/read-more'

export default class extends ReadMore {}


